import $ from 'jquery';
import UIkit from 'uikit';
var updateProducers = function(e) {
    if (e.type == 'shown') {
        $('.px-producers-results-head .uk-badge.uk-badge-primary').not(e.currentTarget).each(function() {
            UIkit.toggle(this).toggle();
        });
    }
    var $activeBadges = $('.px-producers-results-head .uk-badge.uk-badge-primary'), $links = $('[data-term-slugs]');
    $links.addClass('disabled');
    $('.px-producers-archive,.px-recipes-archive').addClass('transitionning');
    window.setTimeout(function(){
        if ($activeBadges.length) {
            $activeBadges.each(function() {
                $links = $links.filter('[data-term-slugs*="'+$(this).data('termSlug')+'"]');
            });
        }
        $links.removeClass('disabled');
        $('.px-producers-archive,.px-recipes-archive').removeClass('transitionning');
    },300)
};
window.addEventListener('px-ready',function() {
    $('.px-producers-results-head .uk-badge').on('shown hidden', updateProducers);
    //$('.px-header').on('active', function() {$('.px-producers-results-head').attr('data-uk-sticky', 'offset:'+$(this).outerHeight()+';animation:uk-animation-slide-top')})
    //$('.px-header').on('inactive', function() {$('.px-producers-results-head').attr('data-uk-sticky', 'offset:0;animation:uk-animation-slide-bottom')})
    $('[data-term-slug]').each(function(){
        //console.log('data-term-slug');
        $(this).attr('data-term-count',$('[data-term-slugs="'+$(this).attr('data-term-slug')+'"]').length)
    })
});
